import React, { useState } from "react";
import { NewTable } from "../index";

// This is a simplified reusable component just for the collapsible sections
const CollapsibleSections = ({ sectionsData }) => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (sectionId) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  return (
    <div className="mt-3 ">
      <div className="">
        {sectionsData.map((section) => (
          <div key={section.id}>
            {/* Top level section */}
            <div
              className="bg-primary text-white inline-flex items-center rounded-sm gap-1 justify-center px-2 py-1 body-two cursor-pointer"
              onClick={() => toggleSection(section.id)}
            >
              <span
                className={`material-symbols-rounded -rotate-90 ${
                  openSections[section.id] ? "rotate-0 " : ""
                }`}
              >
                stat_minus_1
              </span>
              {section.title}
            </div>

            {/* Second level (if first level is open) */}
            {openSections[section.id] && section.children && (
              <div>
                {section.children.map((child) => (
                  <div key={child.id}>
                    <div
                      className="bg-black text-white inline-flex items-center rounded-sm gap-1 justify-center px-2 py-1 ml-8 mt-2 body-two cursor-pointer"
                      onClick={() => toggleSection(child.id)}
                    >
                      <span
                        className={`material-symbols-rounded -rotate-90 ${
                          openSections[child.id] ? "rotate-0 " : ""
                        }`}
                      >
                        stat_minus_1
                      </span>
                      {child.title}
                    </div>

                    {/* Third level (if second level is open) */}
                    {openSections[child.id] && child.children && (
                      <div>
                        {child.children.map((subChild) => (
                          <div key={subChild.id}>
                            <div
                              className="bg-black text-white inline-flex items-center rounded-sm gap-1 justify-center px-2 py-1 ml-12 mt-2 body-two cursor-pointer"
                              onClick={() => toggleSection(subChild.id)}
                            >
                              <span
                                className={`material-symbols-rounded -rotate-90 ${
                                  openSections[subChild.id] ? "rotate-0 " : ""
                                }`}
                              >
                                stat_minus_1
                              </span>
                              {subChild.title}
                            </div>
                            {openSections[subChild.id] &&
                              subChild.tableData && (
                                <div className="ml-16 my-2">
                                  <NewTable
                                    rows={subChild.tableData.rows}
                                    columns={subChild.tableData.columns}
                                    hideToolBar
                                  />
                                </div>
                              )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CollapsibleSections;
